import { Divider as MUIDivider, DividerProps } from '@mui/material';
import React from 'react';

export const Divider = (props: DividerProps) => <MUIDivider {...props} />;
